import {getConfig} from 'config';
import {getData} from '../dataProvider';

export const loadExceptions = () => {
  return getData(`${getConfig('exceptionsUrl')}`);
};
